export default  {
  bindings: {
    propertyGroup: '=',
    properties: '<',
    title: '@'
  },
  controller: 'propertyGroupSaveController',
  template: require('../views/property.group.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.group.save.component.js